import { useEffect, useState } from 'react';

interface UseCountdownProps {
    seconds: number;
    minutes?: number;
    onStop?: (time?: { seconds: string; minutes?: string }) => boolean;
}

type ReturnType<Type> = {
    [Property in keyof Type]: string;
};

const formatTime = (num: number) => {
    return num < 10 ? `0${num}` : num.toString();
};

export const useCountdown = ({ minutes = 0, seconds, onStop }: UseCountdownProps): ReturnType<UseCountdownProps> => {
    const [countDown, setCountDown] = useState(minutes * 60 + seconds);

    const time = {
        minutes: formatTime(Math.trunc(countDown / 60)),
        seconds: formatTime(countDown % 60)
    };

    useEffect(() => {
        let timer: NodeJS.Timeout;
        if (countDown > 0 && !onStop?.(time)) {
            timer = setInterval(() => setCountDown(countDown - 1), 1000);
        }

        return () => clearInterval(timer);
    }, [countDown]);

    return time;
};
